import { Injectable } from '@angular/core';

@Injectable()
export class AhtDivertDomain {
    constructor() { }

    destroy(): void {

    }
}
